
export const formatAuthorizationNumber = (string) => {
    if (string === "") {
        return ""
    }
    else {
        const response = "DK " + string
        return response
    }
}

export const nameTooLong = (name) => {
    if (!name) return false
    return name.length > 35
}

export const sortCardTableByDate = (array) => {
    return array.sort((a, b) => {
        if (a.ValidFrom === b.ValidFrom) {

            if (a.ValidTo === b.ValidTo) {
                return a.Id < b.Id ? 1 : -1;
            }
                return a.ValidTo < b.ValidTo ? 1 : -1;
        }
        return a.ValidFrom < b.ValidFrom ? 1 : -1;
    });
};

export const sortCardTableByCreatedDate = (array) => {
    return array.sort((a, b) => {
        if (a.CreatedDate === b.CreatedDate) {

                return a.Id < b.Id ? 1 : -1;
        }
        return a.CreatedDate < b.CreatedDate ? 1 : -1;
    });
};



export const getEkspeditionsType = (ordertype) => {
    if (ordertype === "Nyudstedelse" || ordertype === "Førstegangsudstedelse") {
        return 0;
    }
    else if (ordertype === "Fornyelse") {
        return 1;
    }
    else if (ordertype === "Erstatning") {
        return 2;
    }
    else if (ordertype === "Udskiftning") {
        return 3;
    }
    return -1

}

export const localDateToUtcDate = (date) => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
}

export const isCardStatusValidForRenewal = (id) => {
    // svarer til: Afsendt, Udløbet, Under udskiftning, Overdraget
    // se reglark i toolkit for hvorfor og opdater arket hvis de valgte status-typer ændres
    let validIds = [3, 10, 11, 15]
    return validIds.includes(id)
}
